module.exports = __webpack_public_path__ + "60537e5d1179301cddb931f72407bb08.svg";